module.exports = __webpack_public_path__ + "static/media/Pluto.e6ed75c2.png";